import { api } from "./api";
import { executarRequisicaoAutenticada } from "./authenticatedRequest";

export interface ExtratoPdfDownload {
  blob: Blob;
  fileName: string;
}

const withAuthorization = (token: string) => ({
  headers: { Authorization: `Bearer ${token}` },
});

const parseFileName = (contentDisposition?: string) => {
  if (!contentDisposition) return undefined;

  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1].replace(/"/g, ""));
  }

  const fileNameMatch = contentDisposition.match(/filename="?([^";]+)"?/i);
  return fileNameMatch?.[1];
};

const formatDatePart = (date: Date) => date.toISOString().slice(0, 10);

export const baixarExtratoPdf = async ({
  dataInicial,
  dataFinal,
  idServicoFinanceiro,
}: {
  dataInicial: Date;
  dataFinal: Date;
  idServicoFinanceiro: number;
}): Promise<ExtratoPdfDownload> => {
  const response = await executarRequisicaoAutenticada((token) =>
    api.get("/StatementReport/Meu", {
      ...withAuthorization(token),
      params: {
        DataInicial: dataInicial.toISOString(),
        DataFinal: dataFinal.toISOString(),
        IdServicoFinanceiro: idServicoFinanceiro,
      },
      responseType: "blob",
    })
  );

  const fileName =
    parseFileName(response.headers?.["content-disposition"]) ||
    `extrato-${formatDatePart(dataInicial)}-${formatDatePart(dataFinal)}.pdf`;

  return {
    blob: response.data,
    fileName,
  };
};

export const baixarExtratoPdfGestor = async ({
  idCredenciaisCliente,
  dataInicial,
  dataFinal,
  idServicoFinanceiro,
}: {
  idCredenciaisCliente: string;
  dataInicial: Date;
  dataFinal: Date;
  idServicoFinanceiro: number;
}): Promise<ExtratoPdfDownload> => {
  const response = await executarRequisicaoAutenticada((token) =>
    api.get("/StatementReport", {
      ...withAuthorization(token),
      params: {
        IdCredenciaisCliente: idCredenciaisCliente,
        DataInicial: dataInicial.toISOString(),
        DataFinal: dataFinal.toISOString(),
        IdServicoFinanceiro: idServicoFinanceiro,
      },
      responseType: "blob",
    })
  );

  const fileName =
    parseFileName(response.headers?.["content-disposition"]) ||
    `extrato-${formatDatePart(dataInicial)}-${formatDatePart(dataFinal)}.pdf`;

  return {
    blob: response.data,
    fileName,
  };
};
